var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.kirby.site)?_c('router-link',{attrs:{"to":"/"}},[_c('ScrollListener',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var scroll = ref.scroll;
return [_c('SideBarGraphic',{attrs:{"scroll":scroll}})]}}],null,false,3187259140)}),_c('ScrollListener',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var scroll = ref.scroll;
return [_c('CurveText',{attrs:{"id":"CurveText","scroll":scroll}})]}}],null,false,1222078067)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }